export default "__VITE_ASSET__DzPjLk67__"